var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ExternalApiService = /** @class */ (function (_super) {
            __extends(ExternalApiService, _super);
            function ExternalApiService(breeze, $q, $http) {
                var _this = _super.call(this, breeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            ExternalApiService.prototype.getExternalApiConfiguration = function (processConfigId) {
                var expand = "myProcessType, " +
                    "myExternalApiConfiguration.myStatusMappings.statusCode, " +
                    "myExternalApiConfiguration.myStatusMappings.myStateMappings.stateCode, " +
                    "myExternalApiConfiguration.myFormMappings.myListMappings.myPropertyMappings, " +
                    "myExternalApiConfiguration.myFormMappings.myListMappings.myPropertyMappings.schemaProperty, " +
                    "myExternalApiConfiguration.myFormMappings.myListMappings.objectSchema, " +
                    "myExternalApiConfiguration.myFormMappings.myPropertyMappings.schemaProperty, " +
                    "myExternalApiConfiguration.myProcessDataMapping.myPropertyMappings.schemaProperty, " +
                    "myExternalApiConfiguration.myProcessDataMapping.myListMappings.objectSchema, " +
                    "myExternalApiConfiguration.myProcessDataMapping.myListMappings.myPropertyMappings.schemaProperty, " +
                    "myExternalApiConfiguration.myReviewMappings.reviewConfiguration";
                var query = this.breezeModule.EntityQuery
                    .from("ProcessConfigurationsLazy")
                    .where('id', '==', processConfigId)
                    .expand(expand);
                return this.fetch(query);
            };
            ExternalApiService.prototype.updateAllMappings = function (processConfigId) {
                var _this = this;
                var params = {};
                var handlerUrl = "api/ExternalApi/UpdateAllMappings/" + processConfigId;
                var result = this.$http.post(handlerUrl, params)
                    .then(function (response) { return _this.handlerResponded(response, params); });
                return result;
            };
            return ExternalApiService;
        }(services.DataService));
        services.ExternalApiService = ExternalApiService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ExternalApiService', ['breeze', '$q', '$http']);
